import { render, staticRenderFns } from "./ResultTip.vue?vue&type=template&id=46d06844&scoped=true"
import script from "./ResultTip.vue?vue&type=script&lang=js"
export * from "./ResultTip.vue?vue&type=script&lang=js"
import style0 from "./ResultTip.vue?vue&type=style&index=0&id=46d06844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d06844",
  null
  
)

export default component.exports